// needs to be set
__webpack_public_path__ = __root_url__ + 'media/templates/site/otu_campaign_mrtoneatc/js/';
global.otuApp = {}

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

require("@babel/polyfill");
require('./redux/store.js');
require('./myjs/webpack.js');
require('./myjs/react.jsx');
require('./myjs/links.js');
require('./myjs/viewport.js');



$( document ).ready(function() {
  console.log( "ready!" );
  otuApp.bindLinks();
});

